type UUID = string;
type URL = string;
type URI = string;

type Config = {
  auth: {
    clientId: UUID;
    redirectUri: string;
    authority: URL;
    knownAuthorities: URI[];
    postLogoutRedirectUri: string;
  };
  cache: {
    cacheLocation: string;
  };
};

export const buildMsalAuthConfig = (
  clientId: UUID,
  authority: URL,
  knownAuthorities: URI[],
  cacheLocation: string,
  redirectUri = typeof window !== 'undefined' ? window.location.origin : '',
): Config => ({
  auth: {
    clientId,
    redirectUri,
    authority,
    knownAuthorities,
    postLogoutRedirectUri: redirectUri,
  },
  cache: { cacheLocation },
});
